import React from 'react'
import { Employee, EmployeePlanInfo } from '../../../interfaces/employee'
import { MainRow, MainTableCell } from './styles'

const onCollapsibleRowClick = (e: any) => {
  const hiddenElement = e.currentTarget.nextSibling

  if (hiddenElement.className.indexOf('collapse show') > -1) {
    hiddenElement.classList.remove('show')
    e.currentTarget.style.background = '#fff'
  } else {
    hiddenElement.classList.add('show')
    e.currentTarget.style.background = '#F8F9FA'
  }
}

export const MainTableRow: React.FC<{
  employee: Employee
  data?: EmployeePlanInfo
  isLoading?: boolean
}> = ({ employee, data, isLoading }) => {
  return (
    <MainRow className="border-top" onClick={onCollapsibleRowClick}>
      <MainTableCell>{employee.id}.</MainTableCell>
      <MainTableCell>{employee.name}</MainTableCell>
      <MainTableCell>{employee.age}</MainTableCell>
      <MainTableCell>{employee.children}</MainTableCell>
      {isLoading ? (
        <MainTableCell />
      ) : (
        <MainTableCell>
          $<span>{Math.round(data?.minEmployerCost || 0)}</span> - $
          <span>{Math.round(data?.maxEmployerCost || 0)}</span>
        </MainTableCell>
      )}
      {isLoading ? (
        <MainTableCell />
      ) : (
        <MainTableCell>
          $<span>{Math.round(data?.minEmployeeCost || 0)}</span> - $
          <span>{Math.round(data?.maxEmployeeCost || 0)}</span>
        </MainTableCell>
      )}
    </MainRow>
  )
}
